import { makeStyles } from '@material-ui/core'

const drawerWidth = 320

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    height: '100%',
    position: 'relative',
    overflow: 'hidden',
    borderRadius: '8px'
  },
  mainWrapper: {
    // flex: 1,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderLeft: '0',
    width: '100%',
    marginRight: -drawerWidth,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    border: 0,
    '& .MuiCard-root': {
      display: 'flex'
    }
  },

  mainWrapperShift: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    }),
    marginRight: 0,
    flexBasis: `calc(100% - ${drawerWidth}px)`,
    maxWidth: `calc(100% - ${drawerWidth}px)`
  },

  ticketHeader: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    zIndex: 1000
  },

  tagsContainer: {
    borderRadius: 0,
    paddingLeft: 85,
    marginTop: '-4px',
    paddingBottom: '4px',
    zIndex: 1000
  }
}))
